import React from 'react';
import { store } from '../Main';
import { updateTicketTimeline } from '../store/actions/ticketActions';
import UnreadNotice from '../components/shared/UnreadNotice';
import IncomingMaterialsNotice from '../components/shared/IncomingMaterialsNotice';
import setSidebarSelected from '../store/actions/sidebarActions';
import { NavItem } from '../constants/navConstants';
import {
  APP_SWITCHER_SELECTED,
  INCOMING_TICKETS_SELECTED,
  MESSAGE_SELECTED,
  NEW_MESSAGE_WINDOW,
  NOTEBOOK_SELECTED,
  TICKETS_SELECTED,
} from '../constants/appConstants';
import AppSwitcher from '../components/shared/AppSwitcher';
import { IS_MESSAGE_WINDOW_OPEN } from '../constants/localStorageConstants';

export const messagesActionItems = {
  messages: {
    tooltip: 'Messages',
    onOpen: () => {
      const isWindowOpen = window.localStorage.getItem(IS_MESSAGE_WINDOW_OPEN);
      if (isWindowOpen === 'true') {
        window.open('', NEW_MESSAGE_WINDOW);
      } else {
        store.dispatch(setSidebarSelected(MESSAGE_SELECTED, true));
      }
    },
    onClose: () => {
      store.dispatch(setSidebarSelected(MESSAGE_SELECTED, false));
    },
    icon: 'icon-messages',
    element: <UnreadNotice />,
    styles: [],
  },
};

export const INCOMING_MATERIALS_NAV_KEY = 'geotrax-incoming-materials';

/**
 * Attaches a badge element to the nav item with the given key (rendered via
 * the item's `element` slot, trucktrax-common >= 1.1.8). Returns new item
 * objects; the source array is left untouched. Reusable for any sidenav item
 * that needs a notification dot — see withIncomingMaterialsNotice.
 */
export const withNavItemElement = (
  navItems: NavItem[],
  key: string,
  element: React.ReactNode,
): NavItem[] => navItems.map(item => (item.key === key ? { ...item, element } : item));

/**
 * Attaches the Incoming Materials notification dot to its route nav item
 */
export const withIncomingMaterialsNotice = (navItems: NavItem[]): NavItem[] =>
  withNavItemElement(
    navItems,
    INCOMING_MATERIALS_NAV_KEY,
    // Route buttons are the large variant — UnreadNotice defaults to the
    // compact action-button placement.
    <IncomingMaterialsNotice variant="route" />,
  );

export const ticketingActionItems = {
  ticketsPopover: {
    tooltip: 'Tickets',
    onOpen: () => {
      store.dispatch(setSidebarSelected(TICKETS_SELECTED, true));
    },
    onClose: () => {
      store.dispatch(setSidebarSelected(TICKETS_SELECTED, false));
      store.dispatch(updateTicketTimeline());
    },
    icon: 'icon-tickets',
    styles: [],
  },
};

export const incomingTicketingActionItems = {
  incomingTicketsPopover: {
    tooltip: 'Incoming Tickets',
    onOpen: () => {
      store.dispatch(setSidebarSelected(INCOMING_TICKETS_SELECTED, true));
    },
    onClose: () => {
      store.dispatch(setSidebarSelected(INCOMING_TICKETS_SELECTED, false));
      store.dispatch(updateTicketTimeline());
    },
    icon: 'icon-tickets',
    // DEV-4154: arrival notification dot, same static pattern as the messages
    // UnreadNotice above. This action button only renders on the incoming
    // materials page (App swaps it in), where the route button drops the dot.
    element: <IncomingMaterialsNotice variant="action" />,
    styles: [],
  },
};

export const notebookActionItems = {
  notebookPopover: {
    tooltip: 'Notebook',
    onOpen: () => {
      store.dispatch(setSidebarSelected(NOTEBOOK_SELECTED, true));
    },
    onClose: () => {
      store.dispatch(setSidebarSelected(NOTEBOOK_SELECTED, false));
      store.dispatch(updateTicketTimeline());
    },
    icon: 'icon-translate',
    styles: [],
  },
};

export const appSelectorActionItems = {
  appPopover: {
    tooltip: 'Apps Menu',
    hideTooltipWhenOpen: true,
    onOpen: () => {
      store.dispatch(setSidebarSelected(APP_SWITCHER_SELECTED, true));
    },
    onClose: () => {
      store.dispatch(setSidebarSelected(APP_SWITCHER_SELECTED, false));
    },
    icon: 'icon-menu',
    element: <AppSwitcher />,
    styles: [],
  },
};
